import { ClassRequestModel, CommonResponse, CreateQuestionBankReqModel, LatestNewQuestionsResponse, LatestQuestionBankResponse, LatestQuestionBankViewReq, MigrateReqModal, QNPIdReq, QuestionBankResponse, QuestionBankViewReq, SubjectClassReqModel } from "@boi/shared-models";
import { Body, Controller, Get, Param, Post } from "@nestjs/common";
import { ApiParam, ApiTags } from "@nestjs/swagger";
import { QuestionBankService } from "./create-question.service";
import { returnException } from "@boi/backend-utils";

@ApiTags('CreateQuestionBank')
@Controller('createQuestionBank')
export class QuestionBankController {
    constructor(private readonly qBankService: QuestionBankService) { }

    @Post('createQuestionBank')
    async createQuestionBank(@Body() req: CreateQuestionBankReqModel): Promise<CommonResponse> {
        try {
            return await this.qBankService.createQuestionBank(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('updateQuestionBank')
    async updateQuestionBank(@Body() req: any): Promise<CommonResponse> {
        try {
            return await this.qBankService.updateQuestionBank(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Get('getQuestionById/:id')
    async getQuestionById(@Param('id') name: number): Promise<CommonResponse> {
        try {
            return await this.qBankService.getQuestionById(name);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getAllQuestionBankData')
    async getAllQuestionBankData(@Body() req: QuestionBankViewReq): Promise<QuestionBankResponse> {
        try {
            return await this.qBankService.getAllQuestionBankData(req);
        } catch (error) {
            return returnException(QuestionBankResponse, error);
        }
    }

    // @Post('GetSingleQuestionBankData')
    // async GetSingleQuestionBankData(@Body() req: QuestionBankViewReq): Promise<LatestQuestionBankResponse> {
    //     try {
    //         return await this.qBankService.GetSingleQuestionBankData(req);
    //     } catch (error) {
    //         return returnException(LatestQuestionBankResponse, error);
    //     }
    // }


    @Post('GetSingleQuestionBankData')
    async GetSingleQuestionBankData(@Body() req: QuestionBankViewReq): Promise<LatestNewQuestionsResponse> {
        try {
            return await this.qBankService.GetSingleQuestionBankData(req);
        } catch (error) {
            return returnException(LatestNewQuestionsResponse, error);
        }
    }

    @Post('getAllLatestQuestionBankData')
    async getAllLatestQuestionBankData(@Body() req: LatestQuestionBankViewReq): Promise<LatestQuestionBankResponse> {
        try {
            return await this.qBankService.getAllLatestQuestionBankData(req);
        } catch (error) {
            return returnException(LatestQuestionBankResponse, error);
        }
    }

    @Post('/activateOrDeactivateQuestion')
    async activateOrDeactivateQuestion(@Body() req: QNPIdReq): Promise<CommonResponse> {
        try {
            return await this.qBankService.activateOrDeactivateQuestion(req)
        } catch (err) {
            return returnException(CommonResponse, err);
        }
    }

    @Post('/activateOrDeactivateLatestQuestion')
    async activateOrDeactivateLatestQuestion(@Body() req: QNPIdReq): Promise<CommonResponse> {
        try {
            return await this.qBankService.activateOrDeactivateLatestQuestion(req)
        } catch (err) {
            return returnException(CommonResponse, err);
        }
    }

    @Post('/getQuestionsCountSummery')
    async getQuestionsCountSummery(@Body() req: ClassRequestModel): Promise<CommonResponse> {
        try {
            return await this.qBankService.getQuestionsCountSummery(req);
        } catch (err) {
            return returnException(CommonResponse, err);
        }
    }

    @Post('/getQuestionSubjectPivot')
    async getQuestionSubjectPivot(@Body() req: ClassRequestModel): Promise<CommonResponse> {
        try {
            return await this.qBankService.getQuestionSubjectPivot(req);
        } catch (err) {
            return returnException(CommonResponse, err);
        }
    }

    @Post('getAllCollegeCodesAndSymbols')
    async getAllCollegeCodesAndSymbols(): Promise<CommonResponse> {
        try {
            return await this.qBankService.getAllCollegeCodesAndSymbols()
        } catch (error) {
            return returnException(CommonResponse, error)
        }
    }

    @Post('getAllQuestionsCountsBySubject')
    async getAllQuestionsCountsBySubject(@Body() req: SubjectClassReqModel): Promise<CommonResponse> {
        try {
            return await this.qBankService.getAllQuestionsCountsBySubject(req)
        } catch (error) {
            return returnException(CommonResponse, error)
        }
    }


    @Post('migrateTabQuestionsToCreateQuestions')
    async migrateTabQuestionsToCreateQuestions(@Body() req: MigrateReqModal): Promise<CommonResponse> {
        try {
            return await this.qBankService.migrateTabQuestionsToCreateQuestions(req)
        } catch (error) {
            return returnException(CommonResponse, error)
        }
    }

}